'use strict'

import React from 'react';
import PropTypes from 'prop-types';

import Layout from './Layout.jsx';
import ProjectMenu from './components/ProjectMenu.jsx';

import Status from './components/Status.jsx';
import {Risk} from './Risk.jsx';
import {Change} from './Change.jsx';
import sortByDate from '../app/utils/sortByDate.js';

import TabReport from './progress/TabReport.jsx';

export class HighlightReport extends React.Component {

  render() {
    var summary=undefined;
    var lastReport=this.props.endProject
      ? undefined
      : (this.props.project!==undefined && this.props.project.highlights!==undefined)
      ? this.props.project.highlights.slice()
        .filter(report=>report.stage===undefined)
        .sort(sortByDate).reverse()[0]
      : {
        summary: {content:"<no previous status summary available>"},
        benefits: {content: "<no previous benefits report available>"},
        cost: {content:"<no previous cost report available>"},
        scope: {content:"<no previous scope report available>"},
        time: {content:"<no previous time report available>"},
        quality: {content:"<no previous quality report available>"},
        risk: {content:"<no previous risk report available>"},
        plannedAchivements: "",
        date:undefined
      };

    var date=new Date();
    var version=this.props.version;
    let endStageReport=this.props.endStage && this.props.project.currentStage!==undefined;
    var from=lastReport!==undefined && lastReport.date!==undefined ? lastReport.date : undefined;;
    if (endStageReport
        && this.props.project.currentStage.time!==undefined
        && this.props.project.currentStage.time.start!==undefined ) {
      try {
        from=new Date(this.props.project.currentStage.time.start).toISOString().slice(0,10);
      } catch (error) {
        console.log("[WARN] Invalid start date for stage on end stage report");
      }
    }

    var performed=lastReport!==undefined ? lastReport.plannedAchivements : undefined;
    if (endStageReport) {
      let comments=this.props.project.currentStage.comments;
      let products=this.props.project.currentStage.scheduleComments;
      if (products!==undefined && products!==null && products.trim().length>0) {
        performed=products;
      } else if (comments!==undefined  && comments!==null && comments.trim().length>0) {
        performed=this.props.project.currentStage.comments.trim();
      }
    }

    var report= {
      overallStatus:{
        status:"green"
      },
      benefits:{
        status:"green"
      },
      time:{
        status:"green"
      },
      cost:{
        status:"green"
      },
      quality:{
        status:"green"
      },
      scope:{
        status:"green"
      },
      risk:{
        status:"green"
      },
      date: date,
      from: from!==undefined ? new Date(from) : undefined,
      performedAchivements: performed
    }
    if (this.props.endProject) {
      if (this.props.project.draftEndProject!==undefined) {
        report=this.props.project.draftEndProject;
        report.from=new Date(report.fromDate);
        report.date=new Date(report.statusDate);
        console.log("Report: "+JSON.stringify(report));
      } else {
        //TODO: Create utility, since these functions are copied from plan
        let sortByStart=(a,b)=> a.time.start<b.time.start ? -1 : a.time.start>b.time.start ? 1 : 0;
        let sortByEnd=(a,b)=>a.time.end>b.time.end ? -1 : a.time.end<b.time.end ? 1 : 0
        let startOf=(stages)=>{
          let sortedStages=(stages!==undefined ? stages : [])
              .filter(stage=>stage!==undefined)
              .filter(stage=>stage.time!==undefined && stage.time.start!==undefined && stage.time.start!==null && stage.time.start.trim().length>0)
              .slice().sort(sortByStart);
            return sortedStages.length>0 && sortedStages[0].time!==undefined ? sortedStages[0].time.start : undefined;
        };
        let endOf=(stages)=>{
          let sortedStages=(stages!==undefined ? stages : [])
            .filter(stage=>stage!==undefined)
            .filter(stage=>stage.time!==undefined && stage.time.end!==undefined && stage.time.end!==null && stage.time.end.trim().length>0)
            .slice().sort(sortByEnd);
          return sortedStages.length>0 && sortedStages[0].time!==undefined ? sortedStages[0].time.end : undefined;
        }
        report.from=startOf(this.props.project.stages);
        report.date=endOf(this.props.project.stages);
      }
    } else if (endStageReport) {
      if (this.props.project.draftEndStage!==undefined) {
        report=this.props.project.draftEndStage;
        report.isSavedDraft=true;
        report.date=new Date(report.statusDate);
        report.from=report.fromDate!==undefined && report.fromDate!==null ? new Date(report.fromDate) : undefined;
      }
    } else if (this.props.project.draftHighlight!==undefined) {
      report=this.props.project.draftHighlight;
      report.isSavedDraft=true;
      report.date=new Date(report.statusDate);
      report.from=report.fromDate!==undefined && report.fromDate!==null ? new Date(report.fromDate) : undefined;
    }
    if (this.props.id!==undefined) {
      let publishedReport=this.props.project!==undefined && this.props.project.highlights!==undefined
        ? this.props.project.highlights.slice().sort(sortByDate).reverse()[0]
        : undefined;
      if (publishedReport!==undefined && this.props.id===publishedReport.id && publishedReport.createdBy===this.props.user.id) {
        lastReport=this.props.project.highlights.filter(r=>r.id!==this.props.id && new Date(r.date).toISOString().slice(0,10)<new Date(publishedReport.date).toISOString().slice(0,10)).sort(sortByDate).slice(-1)[0];
        report=Object.assign({},publishedReport,{
          id: undefined,
          overallStatus: publishedReport.summary,
          replaces: this.props.id
        });
      }
    }
    if (endStageReport) {
      lastReport=undefined;
    }
    let variant=this.props.endProject
      ? "endProject"+(this.props.variant!==undefined ? "#"+this.props.variant : "")
      : this.props.endStage
        ? "endStage"+(this.props.variant!==undefined ? "#"+this.props.variant : "")
        : this.props.project.isRelease===true
          ? "release"+(this.props.variant!==undefined ? "#"+this.props.variant : "")
          : this.props.project.isProduct===true
            ? "product"+(this.props.variant!==undefined ? "#"+this.props.variant : "")
            : this.props.variant;
    return (
      <div style={{paddingTop:20}}>
        <TabReport
          {...this.props}
          variant={variant}
          endStage={endStageReport}
          report={report}
          onCancel={()=>window.location="."}
          lastReport={lastReport}
        />
      </div>
    );
  }
}

export default class HighlightReportPage extends React.Component{
  render() {
    var menu=(this.props.showMenu===true) ? <ProjectMenu {...this.props}/> : undefined;
    return (
      <Layout {...this.props} projectMenu={menu}>
        <HighlightReport {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/HighlightReport.jsx